export const queryKeysFactory = {
  all: ["api"] as const,

  module: (module: string) => [...queryKeysFactory.all, module] as const,

  lists: (module: string) =>
    [...queryKeysFactory.module(module), "list"] as const,
  list: (module: string, filters: Record<string, unknown>) =>
    [...queryKeysFactory.lists(module), filters] as const,

  details: (module: string) =>
    [...queryKeysFactory.module(module), "detail"] as const,
  detail: (module: string, id: string | number) =>
    [...queryKeysFactory.details(module), id] as const,
};
